import React, { useEffect, useRef, useState } from "react";
import { DateTimeArrow, MosaicNoStream, Video_Export } from "../../assets/images";
import { Modal } from "react-bootstrap";
import PopupCard from "../Cameras/PopupCard";
import { ConvertDate, ConvertDateThree, formatJSDateInDDMMYYYY, formatJSDateObject, multiTimeZoneHelper, subtractMinutes } from "../../utils/utils";
import { addMinutes, subMinutes, differenceInMinutes, subDays } from "date-fns";
import { MULTI_TIME_ZONE, UAPI_URL_CCTV } from "../../config";
import { WarningToast } from "../../CustomHooks/WarningToast";
import Calendar from "react-calendar";
import TimerCard from "../Cameras/TimerCard";
import JSZip from "jszip";
import axios from "axios";
import { saveAs } from "file-saver";
import { SuccessToast } from "../../CustomHooks/SuccessToast";
import { ErrorToast } from "../../CustomHooks/ErrorToast";
import { fetchRecordingCameraDetailsById } from "../../services/camera/cameraService";

export const RecordingVideo = ({ playbackList, item }) => {
  // List of video sources for the playlist
  // const videos = [
  //   {
  //     src: "http://192.168.0.129/VideoRepository/Sample_Video.mp4",
  //     type: "video/mp4",
  //   },
  //   {
  //     src: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  //     type: "video/mp4",
  //   },
  //   {
  //     src: "http://192.168.0.129/VideoRepository/Test_Video_File.mp4",
  //     type: "video/mp4",
  //   },
  // ];
  console.log("VBISSUE inside RecordingVideo", playbackList);
  const [videoUrl, setVideoUrl] = useState(playbackList?.playbackURL);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoRef = useRef(null);

  console.log("playbackList", playbackList)

  const [popOpen, setPopOpen] = useState(false);
  const [mode, setMode] = useState("");
  const [date, setDate] = useState(subMinutes(new Date(), 15));
  const [blankDate, setBlankDate] = useState("");
  const [blankDateTwo, setBlankDateTwo] = useState("");
  const [timeStringMain, setTimeStringMain] = useState("+15 min");
  const [timeStringMainTwo, setTimeStringMainTwo] = useState("+5 min");
  const [dateTwo, setdateTwo] = useState(new Date());
  const [dateString, setDateString] = useState("");
  const [dateStringTwo, setDateStringTwo] = useState("");
  const [differenceTime, setDifferenceTime] = useState(15);
  const [differenceTimeTwo, setDifferenceTimeTwo] = useState(15);
  const [timeString, setTimeString] = useState("");
  const [timeStringTwo, setTimeStringTwo] = useState("");
  const [differenceInSeconds, setDifferenceInSeconds] = useState(900);

  useEffect(() => {
      let currentTime;
      if (MULTI_TIME_ZONE) {
        currentTime = multiTimeZoneHelper(item.OffsetMinutes);
      } else {
        currentTime = new Date();
      }
      let d = subMinutes(currentTime, 15);
      let temp = ConvertDate(d);
      let temp_date = temp.slice(0, 10).replace(/-/g, "_");
      setDateString(temp_date);
    }, []);
  
    useEffect(() => {
      let d;
      if (MULTI_TIME_ZONE) {
        d = multiTimeZoneHelper(item.OffsetMinutes);
      } else {
        d = new Date();
      }
      let temp = ConvertDate(d);
      let temp_date = temp.slice(0, 10).replace(/-/g, "_");
      setDateStringTwo(temp_date);
    }, []);

    const dateChange = (v, e) => {
      let d = ConvertDate(v);
      let temp = d.slice(0, 10).replace(/-/g, "_");
      setDateString(temp);
      setDateStringTwo(temp);
      setDate(v);
      setdateTwo(v);
    };


  // useEffect(() => {
  //   setVideoUrl(playbackList?.playbackURL)
  // }, [playbackList]);

  const loadVideo = (index) => {
    if (index >= 0 && index < videoUrl.length) {
      setCurrentVideoIndex(index);
    }
  };

  const nextVideo = () => {
    console.log("next video");
    setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videoUrl.length);
  };

  const handleVideoEnd = () => {
    console.log("video end");
    nextVideo();
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
      videoRef.current.play();
    }
  }, [currentVideoIndex]);

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const exportVideo = () => {
    let timeStringMain = "";
    if (timeString === "") {
      let blankArr = blankDate.split("_");
      for (let i = 0; i < blankArr.length; i++) {
        if (blankArr[i].length == 1) {
          blankArr[i] = "0" + blankArr[i].toString();
        }
      }
      let blankStr = blankArr.join("_");
      timeStringMain = blankStr;
    } else {
      timeStringMain = timeString;
    }
    let temp = dateString + "_" + timeStringMain;
    let arr = temp.split("_");
    let startD = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    let SD = formatDate(
      new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5])
    );

    let timeStringMainTwo = "";
    if (timeStringTwo === "") {
      let blankArr = blankDateTwo.split("_");
      for (let i = 0; i < blankArr.length; i++) {
        if (blankArr[i].length == 1) {
          blankArr[i] = "0" + blankArr[i].toString();
        }
      }
      let blankStr = blankArr.join("_");
      timeStringMainTwo = blankStr;
    } else {
      timeStringMainTwo = timeStringTwo;
    }
    let tempTwo = dateStringTwo + "_" + timeStringMainTwo;
    let arrTwo = tempTwo.split("_");
    let endD = new Date(
      arrTwo[0],
      arrTwo[1] - 1,
      arrTwo[2],
      arrTwo[3],
      arrTwo[4],
      arrTwo[5]
    );
    let ED = formatDate(
      new Date(
        arrTwo[0],
        arrTwo[1] - 1,
        arrTwo[2],
        arrTwo[3],
        arrTwo[4],
        arrTwo[5]
      )
    );

    let currentTime = new Date();
    if (MULTI_TIME_ZONE) {
      currentTime = multiTimeZoneHelper(item.OffsetMinutes);
    }
        let diff = differenceInMinutes(endD, startD);
        let current = new Date();
        if (MULTI_TIME_ZONE) {
          current = multiTimeZoneHelper(item.OffsetMinutes);
        }
        console.log("startD", startD)
        console.log("endD", endD)
        console.log("current", current)
        console.log("startD", startD.toString())
        console.log("endD", endD.toString())
        if(startD.toString() == endD.toString()){
          ErrorToast(
            "Invalid timings"
          );
          return;
        }
        if (startD > current) {
          ErrorToast(
            "Invalid timings, start date time is greater than current time."
          );
          return;
        }
    
        if (endD > current) {
          ErrorToast(
            "Invalid timings, end date time is greater than current time."
          );
          return;
        }
        console.log("Diff", diff)
        if (diff > 15) {
          ErrorToast("Max limit for downloading of video is 15 mins");
          return;
        } else if (diff < 0) {
          ErrorToast("Invalid timings");
          return;
        } else if (diff == 15 && SD.slice(-2) != ED.slice(-2)) {
          ErrorToast("Max limit for downloading of video is 15 mins");
          return;
        }
    
        if (differenceTimeTwo == 0) {
          ErrorToast("The selected time is greater from the current time!");
          return;
        }
        if (SD > currentTime && differenceTimeTwo > 0) {
          ErrorToast("The selected time is greater from the current time!");
          return;
        } else {

          let startDateStr = formatJSDateObject(startD);
          let endDateStr = formatJSDateObject(endD);

          let obj = {
            startTime: formatJSDateInDDMMYYYY(startDateStr),
            endTime: formatJSDateInDDMMYYYY(endDateStr),
            deviceId: item?.ParentCameraID?.toString(),
          };          
          fetchRecordingCameraDetailsById(obj)
            .then((res) => {
              console.log("ResData", res.Data);
              if(res.Status == 'success'){
                if(res.Data.length > 0){
                  downloadZipFile(res.Data);
                }else{
                  ErrorToast('Video Backup does not exist for this time range.')
                  // ErrorToast('Please select a longer time range.')
                }
              }else{
          
              }
            })
        }
  }

  const downloadDirectPlayback = () => {
    console.log("PlaybackUrlList", playbackList?.playbackURL)
    downloadZipFile(playbackList?.playbackURL)
  }

  function extractFilename(url) {
    const parts = url.split('/');
    return parts[parts.length - 1]; // returns '18062025_144207.mp4'
  }

  const downloadZipFile = (fileList) => {
    const zip = new JSZip();
    const filePromises = [];

    fileList.forEach((file) => {
      const proxiedUrl = `${UAPI_URL_CCTV}getVideoSync?url=${encodeURIComponent(file)}`
      console.log('ProxiedUrl', proxiedUrl)
      const promise = axios.get(file, { 
        responseType: 'arraybuffer', 
        // headers: { "Cache-Control": "no-cache" }
      } 
      )
        .then(response => {
          console.log("Download", response)
          const fileName = extractFilename(file);
          zip.file(fileName, response.data);
        })
        .catch(error => console.log('Error fetching file:', error));

      filePromises.push(promise);
    })

    Promise.all(filePromises)
      .then(() => {
        zip.generateAsync({ type: 'blob'})
          .then((blob) => {
            let temp = ConvertDateThree(new Date());
            saveAs(blob, `${item?.CameraName}_${temp}_Video_backup.zip`);
            SuccessToast(`Video backup ZIP file has been downloaded.`)
            setPopOpen(false)
          })
          .catch((err) => console.error('Error generating zip', err))
      })
      .catch((err) => console.error(`Error downloading files: `, err))
  }

  const getDataFromChild = (data) => {
      let timeStringMain = "";
      if (data === "") {
        let blankArr = blankDate.split("_");
        for (let i = 0; i < blankArr.length; i++) {
          if (blankArr[i].length == 1) {
            blankArr[i] = "0" + blankArr[i].toString();
          }
        }
        let blankStr = blankArr.join("_");
        timeStringMain = blankStr;
      } else {
        timeStringMain = data;
      }
      let temp = dateString + "_" + timeStringMain;
      let arr = temp.split("_");
      let SD = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
      let currentTime = new Date();
      if (MULTI_TIME_ZONE) {
        currentTime = multiTimeZoneHelper(item.OffsetMinutes);
      }
      const difference = differenceInMinutes(currentTime, SD);
  
      if (mode == "Playback" && difference < 15 && difference >= 0) {
        WarningToast("Selected Time is less than 15 min !");
        timeStringMain = "+" + difference + " min ";
        setDifferenceTime(parseInt(difference));
        let difSec = parseInt(difference) * 60;
        setDifferenceInSeconds(difSec);
        setTimeStringMain(timeStringMain);
      } else if (mode == "Playback") {
        setDifferenceTime(15);
        setDifferenceInSeconds(900);
        setTimeStringMain("+15 min");
      }
  
      if (mode == "Export" && difference < 5 && difference >= 0) {
        WarningToast("Selected Time is less than 5 min !");
  
        timeStringMain = "+" + difference + " min ";
        setDifferenceTimeTwo(parseInt(difference));
        setTimeStringMainTwo(timeStringMain);
      } else if (mode == "Export") {
        setDifferenceTimeTwo(5);
        setTimeStringMainTwo("+5 min");
      }
  
      setTimeString(data);
    };
  
    const getDataFromChildTwo = (data) => {
      let timeStringMainTwo = "";
      if (data === "") {
        let blankArr = blankDateTwo.split("_");
        for (let i = 0; i < blankArr.length; i++) {
          if (blankArr[i].length == 1) {
            blankArr[i] = "0" + blankArr[i].toString();
          }
        }
        let blankStr = blankArr.join("_");
        timeStringMainTwo = blankStr;
      } else {
        timeStringMainTwo = data;
      }
      let temp = dateStringTwo + "_" + timeStringMainTwo;
      let arr = temp.split("_");
      let SD = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
      let currentTime = new Date();
      if (MULTI_TIME_ZONE) {
        currentTime = multiTimeZoneHelper(item.OffsetMinutes);
      }
      const difference = differenceInMinutes(currentTime, SD);
      if (difference < 5 && difference >= 0) {
        WarningToast("Selected Time is less than 5 min !");
  
        timeStringMainTwo = difference + " min ";
        setDifferenceTimeTwo(parseInt(difference));
        setTimeStringMainTwo(timeStringMain);
      } else {
        setDifferenceTimeTwo(5);
        setTimeStringMainTwo("5 min");
      }
  
      setTimeStringTwo(data);
    };

  return (
    <>
      <div className="HeightChildDiv" style={{ height: "100%"}}>
        <div
          className="hoverDetails"
         style={{ height: "100%", width: "100%", display: "flex", position: "relative" }}
        >
          {
            playbackList?.playbackURL?.length > 0 ? (
              <>
                <div
                  className="PanelDetailDiv"
                  style={{
                    position: "absolute",
                    bottom: "10%",
                    left: "1%",
                  }}>
                  <p><span style={{color:"#b1b1b1"}}>{item.CameraName || item.cameraName || item.deviceName}</span></p>
                </div>

                <video
                  id="videoPlayer"
                  className="NonStretchVideo"
                  controls
                  ref={videoRef}
                  onEnded={handleVideoEnd}
                  autoPlay
                >
                  <source src={videoUrl[currentVideoIndex]} />
                </video>
                {/* <button
                  onClick={() => {
                    setPopOpen(true)
                  }}
                >Export
                </button> */}
                <button
                  data-title="Video Export"
                  className="MosaicButtonDiv videoExportsButtonVB"
                >
                  <img
                    style={{ padding: "2px", height: "24px" }}
                    src={Video_Export}
                    alt="video Export Button"
                    onClick={() => {
                      console.log("Export Video Clicked");
                      setPopOpen(true)
                      let d;
                      if (MULTI_TIME_ZONE) {
                        let offsetMinutes =
                          item.OffsetMinutes || 330;
                        d = multiTimeZoneHelper(offsetMinutes);
                      } else {
                        d = new Date();
                      }
                      setDate(subMinutes(d, 15));
                      setdateTwo(d);
                      setTimeString("");
                      setTimeStringTwo("");
                    }}
                  />
                </button>
              </>
            ) : (
              <div className="singleplaybackNoStream 1111">
                <img
                  src={MosaicNoStream}
                  alt="Video"
                  className="w-100 image-bg mosaic-nostream-img"
                />
                {/* <h1 className="w-100 image-bg mosaic-nostream-img">No Recording Available</h1> */}
                <div
                    className="PanelDetailDiv"
                    style={{
                      position: "absolute",
                      bottom: "3%",
                      left: "1%",
                    }}>
                    <p><span>{item.CameraName || item.cameraName || item.deviceName}</span></p>
                  </div>
              </div>
            )}
        </div>
      </div>
      <Modal
        show={popOpen}
        onHide={() => setPopOpen(false)}
        className="ExportModal"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <p className="ModelHeaderName">
              {/* {item.CameraName || item.cameraName}  */}
              {item?.CameraName} Export
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <PopupCard
            item={item}
            dateChange={dateChange}
            date={date}
            getDataFromChild={getDataFromChild}
            onSubmitBtn={exportVideo}
            setBlankDate={setBlankDate}
            timeStringMain={timeStringMain}
            mode={mode}
            setBlankDateTwo={setBlankDateTwo}
            getDataFromChildTwo={getDataFromChildTwo}
            timeStringMainTwo={timeStringMainTwo}
            dateTwo={dateTwo}
            exportCurrentVideoHide={false}
            videoExportDownload={downloadDirectPlayback}
          /> */}
          <>
            <>

              <div className="popup_link mt-0"
                onClick={downloadDirectPlayback}
              >
                <span>Download Current Video</span>
              </div>
              <div className="ORLine"></div>
            </>
            <div className="popupDiv">
              <div className="popup_card">
                <p className="popup_header">Date and Time</p>
                <Calendar
                  onChange={dateChange}
                  value={date}
                  maxDate={new Date()}
                  minDate={subDays(new Date(), 180)}
                />
              </div>

              <div className="popup_cardTimer">
                <div
                  className="popup_cardTimerRight"
                  style={{ marginRight: "0px" }}
                >
                  <TimerCard
                    dateFromParent={date}
                    getDataFromChild={getDataFromChild}
                    setBlankDate={setBlankDate}
                  />
                </div>
                <div
                  className="popup_cardTimerRightArrow"
                  style={{ margin: "0.5rem" }}
                >
                  <img src={DateTimeArrow} alt="DateTimeArrow" />
                </div>
                <div
                  className="popup_cardTimerRight"
                  style={{ marginRight: "0px" }}
                >
                  <TimerCard
                    dateFromParent={dateTwo}
                    getDataFromChild={getDataFromChildTwo}
                    setBlankDate={setBlankDateTwo}
                  />
                </div>
              </div>

              <div className="popup_link" onClick={exportVideo}>
                <img
                  src={Video_Export}
                  className="playbackicon mr-2"
                  alt="playback icon"
                />
                <span>Export</span>
              </div>

            </div>
          </>

        </Modal.Body>
      </Modal>
    </>
  );
};
